import { render, staticRenderFns } from "./OrderOffers.vue?vue&type=template&id=0be539ec&"
import script from "./OrderOffers.vue?vue&type=script&lang=js&"
export * from "./OrderOffers.vue?vue&type=script&lang=js&"
import style0 from "./OrderOffers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports